(() => {
  const init = () => {
    document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
      if (form.closest('product-form')) return;
      if (form.dataset.registaCartSafety === '1') return;
      form.dataset.registaCartSafety = '1';
      form.addEventListener('submit', async (event) => {
        const idInput = form.querySelector('[name="id"]');
        if (!idInput || !idInput.value) {
          event.preventDefault();
          console.warn('[Regista] Prevented invalid cart/add submit: missing variant id', form);
          return;
        }
        if (window.customElements && customElements.get('product-form')) return;
        event.preventDefault();
        const formData = new FormData(form);
        if (!formData.get('quantity')) formData.set('quantity', '1');
        formData.set('sections', 'cart-drawer,cart-icon-bubble');
        formData.set('sections_url', window.location.pathname);
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            body: formData,
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          });
          const json = await response.json();
          if (!response.ok) throw json;
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
            bubbles: true,
            detail: { baseEvent: 'variant:add', cart: await (await fetch('/cart.js')).json() }
          }));
        } catch (error) {
          console.error('[Regista] Add to cart failed', error);
          alert(error?.description || error?.message || 'לא ניתן להוסיף את המוצר לסל כרגע');
        }
      });
    });
  };
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
// Best Custom Product Options (the patch / name / number options) adds products to the cart itself and then sends the
// customer to /cart. Its "bcpo:afterAdd" hook lets the theme take over that last step: refresh the cart drawer and open
// it instead. Without a cart drawer on the page, the app's redirect still happens.
(() => {
  const openCartDrawer = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return false;

    let shown = false;
    const show = () => {
      if (shown) return;
      shown = true;
      drawer.show();
    };

    drawer.addEventListener('cart-drawer:refreshed', show, { once: true });
    setTimeout(show, 2500);
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    return true;
  };

  // The app loads on its own schedule, so connect to it once it exists (at the latest, on the add-to-cart click)
  const hookBcpo = () => {
    if (hookBcpo.done || !window.bcpo?.$) return;
    hookBcpo.done = true;
    window.bcpo.$(document).on('bcpo:afterAdd', openCartDrawer);
  };

  hookBcpo();
  document.addEventListener('click', hookBcpo, true);
  document.addEventListener('submit', hookBcpo, true);
})();